// extracted by mini-css-extract-plugin
export default {"services_wrapper":"KeyServices_services_wrapper__jbQg9","services_grid":"KeyServices_services_grid__Tz5xX"};